/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC } from 'react';
import { Route, Switch } from 'react-router-dom';
import NotAllowed from 'src/permissions/not-allowed';
import useVendorData from 'src/services/hooks/useVendorData';
import FlashProductsIncludedPage from './pages/included';
import FlashProductsPageContent from './pages/index';

const FlashProductsRootPage: FC = () => {
  const { _checkField } = useVendorData();

  if (!_checkField('flashSaleVisible', true) || !_checkField('flashSaleProduct', true)) {
    return <NotAllowed />;
  }

  return (
    <Switch>
      <Route path="/flash-products" exact>
        <FlashProductsPageContent />
      </Route>

      <Route path="/flash-products/included" exact>
        <FlashProductsIncludedPage />
      </Route>
    </Switch>
  );
};

export default FlashProductsRootPage;
